module.exports = __webpack_public_path__ + "static/media/7C.f4633463.jpg";